export default "__VITE_ASSET__P2mQedUZ__"